import React, { useRef } from 'react';
import * as S from './styles';
// import Events from '../../Events';
function Home1() {
  const divRef = useRef<HTMLDivElement | null>(null); // Especificando que o ref pode ser de um HTMLDivElement ou null

  const scrollToDiv = () => {
    divRef.current && divRef.current.scrollIntoView({ behavior: 'smooth' }); // Scroll suave até a div
  };
  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <div>
            <h3>Serviços</h3>
          </div>
          <p>
            Descubra os serviços do Travessias, desde atendimento clínico até a
            promoção de uma psicanálise plural e diversa.
          </p>
          <button onClick={scrollToDiv}>Ver mais</button>
        </S.TextDiv>
      </S.Section>
      <div ref={divRef} style={{ marginTop: '0px' }} />
    </S.Main>
  );
}

export default Home1;
